document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('[data-back-in-stock-button]');
  const submitButtons = document.querySelectorAll('[data-back-in-stock-submit]');
  
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Hide the button
      this.style.display = 'none';
      
      // Show the form
      const container = this.nextElementSibling;
      if (container && container.matches('[data-back-in-stock-container]')) {
        container.classList.remove('hidden');
        
        // Focus the email input
        const emailInput = container.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.focus();
        }
      }
    });
  });

  // Handle submit button clicks
  submitButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const email = document.getElementById("back-in-stock-email").value;
      const variantId = document.getElementById("selected-variant-id").value;
      
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      try {
        const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=LFDYCZ', {
          method: 'POST',
          headers: {
            'accept': 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            'revision': '2025-01-15'
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          // Success! Hide the form and show a success message
          const container = document.getElementById('back-in-stock-form');
          container.innerHTML = '<div class="text-center p-4"><p class="text-sm">Thanks! We\'ll email you when this product is back in stock.</p></div>';
          
          // If they checked subscribe, you might want to trigger a separate Klaviyo list subscription
          // if (subscribe) {
          //   const subscribeOptions = {
          //     method: 'POST',
          //     headers: {
          //       'Content-Type': 'application/vnd.api+json',
          //       'revision': '2025-01-15'
          //     },
          //     body: JSON.stringify({
          //       data: {
          //         type: 'subscription',
          //         attributes: {
          //           profile: {
          //             data: {
          //               type: 'profile',
          //               attributes: {
          //                 email: email,
          //                 subscriptions: {
          //                   email: {
          //                     marketing: {
          //                       consent: 'SUBSCRIBED'
          //                     }
          //                   }
          //                 }
          //               }
          //             }
          //           },
          //           custom_source: 'back_in_stock'
          //         },
          //         relationships: {
          //           list: {
          //             data: {
          //               type: 'list',
          //               id: 'LRmVPv'  // Your newsletter list ID
          //             }
          //           }
          //         }
          //       }
          //     })
          //   };

          //   fetch('https://a.klaviyo.com/client/subscriptions?company_id=LFDYCZ', subscribeOptions)
          //     .then(response => {
          //       if (!response.ok) {
          //         console.error('Newsletter subscription failed:', response.statusText);
          //       }
          //     })
          //     .catch(error => {
          //       console.error('Newsletter subscription error:', error);
          //     });
          // }
        } else {
          throw new Error('Subscription failed');
        }
      } catch (error) {
        console.error('Error:', error);
        // Show error message to user
        const errorDiv = form.querySelector('.error-message') || document.createElement('div');
        errorDiv.className = 'error-message text-red-500 text-sm mt-2';
        errorDiv.textContent = 'Sorry, there was an error. Please try again.';
        if (!form.querySelector('.error-message')) {
          form.appendChild(errorDiv);
        }
      }
    });
  });
}); 